export default __webpack_public_path__ + "static/preschool5-601f8828e8d4e4c6cd33cba9b73d0b70.jpg";